import { render, staticRenderFns } from "./ModalStatus.vue?vue&type=template&id=18b2d710"
import script from "./ModalStatus.vue?vue&type=script&lang=js"
export * from "./ModalStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports